import {
  Button,
  Pagination,
  Table,
  Tag,
  message,
  Tooltip,
  Popover,
  Spin,
  Popconfirm,
  Modal,
  Form,
  Input,
  Select,
  Row,
  Col,
} from "antd";
import { useSelector } from "react-redux";
import moment from "moment";
import { CiMail, CiRead } from "react-icons/ci";
import { IoCopyOutline } from "react-icons/io5";
import { IoMailOutline, IoSendOutline } from "react-icons/io5";
import Slots from "../../../config/timeSlots.json";
import API from "../../../config/api";
import { useNavigate } from "react-router-dom";
import QRCode from "react-qr-code";
import { LuMousePointer2 } from "react-icons/lu";
import { FaWhatsapp } from "react-icons/fa";
import { useState } from "react";
import { POST, PUT } from "../../../utils/apiCalls";
import NoImage from "../../../assets/images/noimage.jpg";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { AiOutlineLogout, AiOutlineLogin } from "react-icons/ai";

function DataTable(props: any) {
  const navigation = useNavigate();
  const Events = useSelector((state: any) => state.Events);
  const user = useSelector((state: any) => state.User.user);

  const [loading, setLoading] = useState(false);
  const [mailModalVisible, setMailModalVisible] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [mailForm] = Form.useForm();

  const showSlot = (value: any) => {
    let slot = Slots?.filter((i: any) => i.value === value);
    return slot[0];
  };

  const copyToClipBoard = (token: any) => {
    let link = `${API.WEB_URL}/vc-details/${token}/?event=${Events?.defult?.id}`;
    navigator.clipboard.writeText(link).then(() => {
      message.success("Link copied");
    });
  };

  const sendMail = async (item: any) => {
    setSelectedItem(item);
    setMailModalVisible(true);
    mailForm.setFieldsValue({
      mail: item?.email
    });
  };

  const sendMailWithModal = async (values: any) => {
    try {
      setLoading(true);
      let link = `${API.WEB_URL}/vc-details/${selectedItem.uuid}/?event=${Events?.defult?.id}`;
      let obj = {
        image: Events?.defult?.image,
        name: Events?.defult?.title,
        url: link,
        subject: `Scan to know ${selectedItem?.company}'s Meetings`,
        to: values?.mail,
        ccMails: values?.cc || [], // Changed from 'cc' to 'ccMails' to match server API
      };
      let response: any = await POST(API.URL_SHARE_MAIL, obj);
      if (response.status) {
        message.success(response.message);
        setMailModalVisible(false);
        setSelectedItem(null);
        mailForm.resetFields();
      } else {
        message.error("Oops.something gone wrong.");
      }
      setLoading(false);
    } catch (err) {
      message.error("Oops.something gone wrong.");
      setLoading(false);
    }
  };

  const handleMailModalClose = () => {
    setMailModalVisible(false);
    setSelectedItem(null);
    mailForm.resetFields();
  };

  const sendWhatsapp = (item: any) => {
    const message = `Click to view ${item?.company}'s Meetings ${API.WEB_URL}/vc-details/${item.uuid}/?event=${Events?.defult?.id}`;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me?text=${encodedMessage}`;
    window.open(whatsappUrl, "_blank");
  };

  const columns: any = [
    {
      title: "",
      dataIndex: "logo",
      key: "logo",
      width: 50,
      render: (item: any) => (
        <div>
          <img
            src={item || NoImage}
            style={{
              width: 50,
              height: 50,
              objectFit: "contain",
              backgroundColor: "#f5f5f5",
              borderRadius: 100,
              overflow: "hidden",
            }}
          />
        </div>
      ),
    },
    {
      title: "Company",
      dataIndex: "company",
      key: "company",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'], // Added

    },
    {
      title: "Job",
      dataIndex: "jobTitle",
      key: "jobTitle",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'], // Added
    },
    {
      title: "Contact Person",
      dataIndex: "fullname",
      key: "fullname",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'], // Added
    },
    {
      title: "Time Slots",
      dataIndex: "timeSlots",
      key: "timeSlots",
      width: 150,
      render: (item: any) => <Tag>{showSlot(item)?.label}</Tag>,
      sorter: true,
      sortDirections: ['ascend', 'descend'], // Added
    },
    {
      title: "Room",
      dataIndex: "meeting_room",
      key: "meeting_room",
      width: 50,
      sorter: true,
    },
    {
      title: "Slots",
      key: "slots",
      width: 50,
      sorter: (a: any, b: any) => a.slots - b.slots, // Custom sorter for numeric comparison
      sortDirections: ['ascend', 'descend'],
      render: (_: any, record: any) => (
        <div>
          {record.slots}/{showSlot(record.timeSlots)?.slots}
        </div>
      ),
    },
    {
      title: "Registerd On",
      dataIndex: "createdAt",
      key: "createdAt",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>{moment(item).format("MMM D, YYYY h:mm:ss A")}</div>
      ),
    },
    {
      title: "Updated At",
      dataIndex: "updatedAt",
      key: "updatedAt",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'],
      render: (item: any) => (
        <div style={{ fontSize: 12 }}>{moment(item).format("MMM D, YYYY h:mm:ss A")}</div>
      ),
    },
    {
      title: "Attendance",
      dataIndex: "has_attended",
      key: "has_attended",
      width: 150,
      sorter: true,
      sortDirections: ['ascend', 'descend'], // Added
      onCell: (record: any) => ({
        onClick: (event: any) => handleCellClick(event, "Attendance", record),
      }),
      render: (value: any, item: any) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            padding: "10px",
            transition: "background 0.3s ease",
          }}
        >
          <span
            style={{
              fontWeight: 500,
              fontSize: "14px",
              color: value ? "#52c41a" : "#f5222d",
            }}
          >
            {value ? (
              <Tag
                color="green"
                style={{ width: 100, textAlign: "center", cursor: "default" }}
              >
                Attended
              </Tag>
            ) : (
              <Tag
                color="red"
                style={{ width: 100, textAlign: "center", cursor: "default" }}
              >
                Not Attended
              </Tag>
            )}
          </span>
          <Button
            size="small"
            type="primary"
            style={{
              fontSize: "12px",
              background: value ? "#ff4d4f" : "#52c41a",
              borderColor: value ? "#ff4d4f" : "#52c41a",
              color: "#fff",
              transition: "all 0.3s ease",
            }}
            onClick={() =>
              props.updateAttendance({
                id: item?.uuid,
                investor_id: item?.id,
                has_attended: !value,
              })
            }
          >
            {value ? (
              <Tooltip title="Check Out">
                <AiOutlineLogout size={20} />
              </Tooltip>
            ) : (
              <Tooltip title="Check In">
                <AiOutlineLogin size={20} />
              </Tooltip>
            )}
          </Button>
        </div>
      ),
    },

    {
      title: "Actions",
      width: 150,
      onCell: (record: any) => ({
        onClick: (event: any) => handleCellClick(event, "Actions", record),
      }),
      align: "center" as const,
      render: (item: any) => (
        <div className="table-item">
          <div onClick={() => navigation(`/company/ivsdetails/${item.uuid}`)}>
            <Tooltip
              placement="top"
              title={<div style={{ fontSize: 10 }}>Profile Details</div>}
            >
              <CiRead size={25} color="#000" />
            </Tooltip>
          </div>

          <Popover
            placement="bottom"
            trigger={"click"}
            overlayStyle={{ width: 250 }}
            content={
              <>
                {Array.isArray(user.access[Events?.defult?.id]) &&
                  user.access[Events?.defult?.id].includes(8) ? null :
                  <div className="d-flex gap-4 justify-content-center">
                    {" "}
                    {loading ? (
                      <Button size="small">
                        <Spin size="small" />
                      </Button>
                    ) : (
                      <Tooltip
                        placement="bottom"
                        title={
                          <div style={{ fontSize: 10 }}>Share QR via mail</div>
                        }
                      >
                        <Button size="small" onClick={() => sendMail(item)}>
                          <CiMail size={20} />
                        </Button>
                      </Tooltip>
                    )}
                    <Tooltip
                      placement="bottom"
                      title={
                        <div style={{ fontSize: 10 }}>Share QR via whatsapp</div>
                      }
                    >
                      <Button size="small" onClick={() => sendWhatsapp(item)}>
                        <FaWhatsapp size={20} />
                      </Button>
                    </Tooltip>
                    <Tooltip
                      placement="bottom"
                      title={
                        <div style={{ fontSize: 10 }}>Copy Profile Link</div>
                      }
                    >
                      <Button
                        size="small"
                        onClick={() => copyToClipBoard(item?.uuid)}
                      >
                        <IoCopyOutline size={20} />
                      </Button>
                    </Tooltip>
                  </div>
                }
                <div className="d-flex flex-column gap-2 text-center p-3">
                  <div className="d-flex flex-column justify-content-center align-items-center">
                    <img src={Events?.defult?.image} alt="" width={20} />{" "}
                    {Events?.defult?.title}
                  </div>
                  <div>
                    <QRCode
                      size={100}
                      value={`${API.WEB_URL}/vc-details/${item.uuid}/?event=${Events?.defult?.id}`}
                      viewBox={`0 0 256 256`}
                      bgColor={"transparent"}
                      fgColor={"#0026ab"}
                    />
                    <div style={{ fontSize: 10, marginTop: 10 }}>
                      Scan to know {item?.company}'s Meetings
                    </div>
                  </div>
                </div>
              </>
            }
          >
            <LuMousePointer2 size={20} color="green" />
          </Popover>
          {Array.isArray(user.access[Events?.defult?.id]) &&
            user.access[Events?.defult?.id].includes(8) ? null :
            <div onClick={() => props.meetings(item)}>
              <Button size="small" type="primary" style={{ fontSize: 12 }}>
                Meetings
              </Button>
            </div>
          }
          {Array.isArray(user.access[Events?.defult?.id]) &&
            user.access[Events?.defult?.id].includes(8) ? null :
            <Popconfirm
              placement="bottomLeft"
              title="Delete"
              description="Are you sure to delete this?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => {
                props?.delete(item?.id);
              }}
            >

              <div>
                <Tooltip
                  placement="top"
                  title={<div style={{ fontSize: 10 }}>Delete Corporate</div>}
                >
                  <IoIosCloseCircleOutline size={25} color="red" />
                </Tooltip>
              </div>
            </Popconfirm>}
        </div>
      ),
    },
  ];
  const handleRowClick = (record: any) => {
    navigation(`/company/ivsdetails/${record.uuid}`);
  };
  const handleCellClick = (event: any, column: any, record: any) => {
    if (column !== "Actions" && column !== "Attendance") {
      handleRowClick(record);
    } else {
      event.stopPropagation();
    }
  };
  // Modified handleTableChange in DataTable
  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let sortBy = sorter.field;
    let sortOrder = sorter.order === 'ascend' ? 'ASC' : sorter.order === 'descend' ? 'DESC' : '';

    if (props.onSortChange) {
      props.onSortChange(sortBy, sortOrder);
    }
  };

  return (
    <>
      {/* Mail Modal */}
      <Modal
        title="Send Email"
        open={mailModalVisible}
        onCancel={handleMailModalClose}
        footer={false}
        centered
        width={600}
      >
        <Form
          form={mailForm}
          onFinish={sendMailWithModal}
          initialValues={{
            countryCode: "+971",
          }}
        >
          <div className="label">To</div>
          <Form.Item
            name="mail"
            rules={[
              {
                required: true,
                message: "Missing Email",
              },
              { type: "email", message: "Email not valid" },
            ]}
          >
            <Input
              size="large"
              addonBefore={
                <IoMailOutline
                  style={{ marginRight: 10 }}
                  size={20}
                  color="blue"
                />
              }
            />
          </Form.Item>

          <div className="label">CC</div>
          <Form.Item
            name="cc"
            rules={[
              {
                validator: async (_, value) => {
                  if (!value || value.length === 0) return Promise.resolve();
                  const isBasicEmail = (raw: string) => {
                    const v = (raw || "").trim();
                    if (!v) return false;
                    if (/\s/.test(v)) return false;
                    const at = v.indexOf("@");
                    const dot = v.lastIndexOf(".");
                    return at > 0 && dot > at + 1 && dot < v.length - 1;
                  };
                  const isValid = (value as string[]).every((v) =>
                    isBasicEmail(v)
                  );
                  return isValid
                    ? Promise.resolve()
                    : Promise.reject(
                      new Error("Enter valid CC emails (e.g., name@domain.com)")
                    );
                },
              },
            ]}
          >
            <Select
              mode="tags"
              size="large"
              placeholder="CC"
              allowClear
              showSearch
              tokenSeparators={[",", ";", " "]}
            />
          </Form.Item>
          <Row>
            <Col sm={12}>
              <Button size="large" block danger onClick={handleMailModalClose}>
                Close
              </Button>
            </Col>
            <Col sm={12}>
              <Button
                size="large"
                type="primary"
                block
                htmlType="submit"
                icon={<IoSendOutline />}
                loading={loading}
              >
                Send
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>

      <Table
        rowKey="id"
        rowSelection={props.bulkMode ? {
          selectedRowKeys: props.selectAllEvent
            ? props.data.map((item: any) => item.id)
            : props.selectedVcIds,
          preserveSelectedRowKeys: true,
          onChange: (keys: any[]) => {
            if (!props.selectAllEvent) props.setSelectedVcIds(keys);
          },
          getCheckboxProps: () => ({ disabled: props.selectAllEvent }),
        } : undefined}
        size="small"
        scroll={{ x: 'max-content' }}
        onRow={(record) => ({
          onClick: () => {
            if (!props.bulkMode) handleRowClick(record);
          },
        })}
        onChange={handleTableChange}
        style={{ cursor: "pointer" }}
        dataSource={props?.data}
        columns={columns}
        pagination={false}
        loading={props?.loading}
        showSorterTooltip={false}
      />
      <br />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        <Pagination
          defaultCurrent={props?.meta?.page}
          defaultPageSize={props?.meta?.take}
          total={props?.meta?.total_count}
          showSizeChanger
          showTotal={(total: any) => `Total ${props?.meta?.total_count} Corporates`}
          onChange={(page, pageSize) => props.onPageChange(page, pageSize)}
          pageSizeOptions={["1", "12", "24", "48"]}
        />
      </div>
    </>
  );
}

export default DataTable;